import React from 'react';
import { compose } from 'ramda';
import styleFile from './header.js';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import HeaderLogo from './HeaderLogo.jsx';
import LoginModule from './LoginModule.jsx';
import LangSelector from './LangSelector.jsx';
import PhoneSelector from './PhoneSelector.jsx';

const MobilePreheader = compose(withThemeJSS({ styleFile, displayName: 'Header' }))(props => {
  const { classes } = props.theme.styles;
  const { hasHeaderConfig, langActive, countryCode } = props;

  return (
    <div className={classes.mobilePreheader}>
      <div className={classes.mobilePreheaderContainer}>
        { hasHeaderConfig('show_logo') && <HeaderLogo langCode={langActive}/> }
        <div className={classes.userConfigsContainer}>
          { hasHeaderConfig('login_module') && <LoginModule/> }
          { hasHeaderConfig('show_phone') && (
            <PhoneSelector/>
          )}
          { hasHeaderConfig('lang_selector') && <LangSelector countryCode={countryCode} langActive={langActive}/> }
        </div>
      </div>
    </div>
  );
});

export default MobilePreheader;